import { Component, ElementRef, forwardRef, Input, OnInit, ViewChild } from '@angular/core'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { bounceIn } from 'ng-animate'
import { transition, trigger, useAnimation } from '@angular/animations'
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

const _uniqueIdCounter: number = 0

@UntilDestroy()
@Component({
    selector: 'mg-ui-rounded-email-input',
    templateUrl: './ui-rounded-email-input.component.html',
    styleUrls: ['./ui-rounded-email-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UiRoundedEmailInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => UiRoundedEmailInputComponent),
            multi: true,
        },
    ],
    animations: [trigger('bounceIn', [transition(':enter', useAnimation(bounceIn))])],
})
export class UiRoundedEmailInputComponent extends AbstractValueAccessor implements OnInit {
    @Input()
    label: string = ''

    @Input()
    placeholder: string = ''

    @ViewChild('input', { static: true })
    input: ElementRef

    validationPattern = '[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}'

    validationRegex = new RegExp(`^${this.validationPattern}$`)

    formControl: FormControl

    private _disabled: boolean

    @Input()
    get disabled(): boolean {
        return this._disabled
    }

    set disabled(value: boolean) {
        this._disabled = value

        if (this.formControl) {
            this.formControl[value ? 'disable' : 'enable']()
        }
    }

    // tslint:disable-next-line:variable-name
    __value: any = ''

    get _value() {
        return this.__value
    }

    set _value(value) {
        this.__value = value

        if (this.formControl && value !== this.formControl.value) {
            this.formControl.setValue(value)
        }
    }

    get isValid() {
        return this.value && this.value.length && this.validationRegex.test(this.value)
    }

    ngOnInit() {
        this.formControl = new FormControl(this.__value)
        if (this.disabled) {
            this.formControl.disable()
        }
        this.formControl.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
            this.value = this.formControl.value
        })
    }

    setDisabledState?(isDisabled: boolean) {
        this._disabled = isDisabled
    }

    validate() {
        return this.isValid ? null : { email: false }
    }

    public focus(): void {
        this.input.nativeElement.focus()
    }
}
